/**
 * Shopify cart refresh adapter for the RT configurator embed.
 *
 * Registers window.__refreshCart so the configurator's postMessage
 * parent script can call it after adding items to the cart.
 *
 * The configurator itself is ecommerce-agnostic — it only calls
 * window.__refreshCart?.() and does not contain any Shopify logic.
 *
 * To adapt this to another platform, replace the body of refreshCart()
 * with the relevant cart-refresh logic for that platform and load this
 * file (or an equivalent) alongside the configurator embed.
 */
(function () {
  if (window.__refreshCart) return;

  function refreshCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
      .then((r) => r.json())
      .then((sectionsData) => {
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents({ sections: sectionsData });
        } else {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sectionsData['cart-icon-bubble']) {
            const parsed = new DOMParser().parseFromString(
              sectionsData['cart-icon-bubble'],
              'text/html'
            );
            const fresh = parsed.querySelector('.shopify-section');
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'configurator' });
        }
      })
      .catch((e) => console.error('[configurator-cart-refresh]', e));
  }

  window.__refreshCart = refreshCart;
})();
